import config from '../../../config/configs';

const { REGEXPS } = config;

export default function validDomain(domain: any) {
  return domain && (!domain.length || new RegExp(REGEXPS.SIMPLE_DOMAIN).test(domain));
}

